export default __webpack_public_path__ + "static/media/assessment_glide_1_1.8589b2c2.svg";